import EventBus from 'diagram-js/lib/core/EventBus';
import {TrackingChangeBaseBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/tracking-change-base-behavior';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import {CommandType} from '@ispm/shared/bpmn-io/bpmn-js';

export class MarkConnectionAddedBehavior extends TrackingChangeBaseBehavior {

  constructor(eventBus: EventBus, moddle, modeling, bpmnExtensionHelper: BpmnExtensionHelper) {
    super(eventBus, moddle, modeling, bpmnExtensionHelper);
    super.postExecuted([CommandType.CONNECTION_APPEND], this.markElementForChange.bind(this));
  }


  extractElementsFromEvent(event) {
    return [event.context.connection];
  }

  getChangeType() {
    return 'added';
  }

}
